import React, { useEffect, useMemo, useState } from "react";
import axios from "../../../services/axios";
import { DropdownV2 } from "../../FormControlsV2";
import { IOptionProps, IOptionsProps } from "../../../@types/reactSelect/IOption";
import { useTaskCreation } from "../../../hooks/useTaskCreation";
import { useTranslation } from "react-i18next";
import { getLocalizedApiName, LocalizedApiName } from "../../../utils/i18n/getLocalizedApiName";

function formatMachineTypeLabel(name: string): string {
  if (!name) return name;
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}

interface SoilPreparationProps { }

type MachineType = {
  id: number;
  name: LocalizedApiName;
};

export const SoilPreparation: React.FC<SoilPreparationProps> = () => {
  const { t, i18n } = useTranslation();
  const [machineTypes, setMachineTypes] = useState<MachineType[]>([]);
  const machineTypeOptions = useMemo<IOptionsProps>(
    () => machineTypes.map((machineType) => ({
      label: formatMachineTypeLabel(getLocalizedApiName(machineType.name, i18n.language)),
      value: machineType.id,
    })),
    [machineTypes, i18n.language]
  );
  const [selectedMachine, setSelectedMachine] = useState<IOptionProps | null>(null);

  const {
    payload,
    setPayload,
    setAllowTaskCreation,
    responsibleId,
    microAreaId,
  } = useTaskCreation();

  useEffect(() => {
    axios
      .get("/tasks/soil-preparation/machine-types")
      .then((response) => {
        setMachineTypes(response.data);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    setSelectedMachine((current) => {
      if (!current) return current;
      return machineTypeOptions.find((option) => option.value === current.value) || null;
    });
  }, [machineTypeOptions]);

  const handleMachineTypeChoice = (opt: IOptionProps | null) => {
    setSelectedMachine(opt);
    const machineId = opt?.value;
    if (machineId === undefined || machineId === null) return;
    const changes = {
      micro_area_id: microAreaId,
      assigned_user_id: responsibleId,
      machine_type_id: machineId,
    };
    setPayload({ ...payload, changes: [changes] });
    setAllowTaskCreation(true);
  };

  return (
    <>
      <DropdownV2
        name="soil-preparation-machine"
        placeholder={t("taskCreation.fields.selectImplement")}
        label={t("taskCreation.fields.implement")}
        options={machineTypeOptions}
        value={selectedMachine}
        menuMount="overlay"
        onChange={(opt) => handleMachineTypeChoice(opt)}
      />
    </>
  );
};
